import { axios } from '@Root/API'

export const remove = id => {
  return axios.delete(`notes/applications/${id}`)
}
